import { NotificationChannel, NotificationTopic } from './enums'

/**
 * Sujets (`NotificationTopic`) pour lesquels `sphere-notification-service` déclenche
 * déjà des livraisons (email et/ou push). Tenir à jour avec :
 * - `apps/typescript-services/sphere-notification-service/src/learning-activity/rabbitmq-learning-activity.service.ts`
 * - `apps/typescript-services/sphere-notification-service/src/weekly-summary/rabbitmq-weekly-summary.service.ts`
 */
export const NOTIFICATION_TOPICS_IMPLEMENTED_IN_ORCHESTRATOR: readonly NotificationTopic[] =
  [
    NotificationTopic.SYSTEM,
    NotificationTopic.CLASS,
    NotificationTopic.ACTIVITY,
    NotificationTopic.REMINDERS,
  ]

export const NOTIFICATION_CHANNELS_WITH_ORCHESTRATOR_DELIVERY: readonly NotificationChannel[] =
  [NotificationChannel.EMAIL, NotificationChannel.PUSH]
